import React, { useEffect, useState } from 'react';
import { Drawer } from 'antd';
import { Dayjs } from 'dayjs';
import { Appointment } from '../../services/appointmentApi';

interface Employee {
  id: number;
  first_name: string;
  last_name: string;
  role: string;
}

interface QuickBookingDrawerProps {
  visible: boolean;
  appointment: Appointment | null;
  date: Dayjs;
  employees: Employee[];
  onClose: () => void;
}

export const QuickBookingDrawer: React.FC<QuickBookingDrawerProps> = ({
  visible,
  appointment,
  date,
  employees,
  onClose
}) => {
  const [drawerWidth, setDrawerWidth] = useState<number | string>(600);

  useEffect(() => {
    const updateWidth = () => {
      if (window.innerWidth <= 768) {
        setDrawerWidth('100vw');
      } else {
        setDrawerWidth(600);
      }
    };

    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  return (
    <Drawer
      title={appointment ? 'Edit Appointment' : 'New Appointment'}
      open={visible}
      onClose={onClose}
      width={drawerWidth}
      destroyOnHidden
    >
      <div style={{ padding: '24px', textAlign: 'center' }}>
        <p>Quick booking drawer - Full implementation coming in Phase 4</p>
        <p>For now, use the existing appointment modal</p>
      </div>
    </Drawer>
  );
};
